/** cents → "$1,234.56". Always shows two decimals. */
export function dollars(cents: number, opts?: { compact?: boolean }): string {
  const v = (cents ?? 0) / 100;
  if (opts?.compact && Math.abs(v) >= 1000) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(v);
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

/** Same but no $ prefix. */
export function dollarsBare(cents: number): string {
  return ((cents ?? 0) / 100).toFixed(2);
}

export function pct(n: number, fractionDigits = 1): string {
  if (!Number.isFinite(n)) return "—";
  return `${n.toFixed(fractionDigits)}%`;
}

export function intFmt(n: number): string {
  return new Intl.NumberFormat("en-US").format(n ?? 0);
}
